import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import * as Styled from './instruction.styled';
const IMAGE_WIDTH = 350;
const IMAGE_HEIGHT = 200;
export const Instruction = React.memo(function Instruction() {
  const thankYouContent = useEdgeConfigWidget(WidgetId.ThankYouContent);
  return <Styled.Wrapper>
      {thankYouContent.repeaters.steps.map((step, index) => <Styled.Step key={index}>
          <Styled.Number>{index + 1}</Styled.Number>
          <Styled.Preview src={step.images.preview.src} alt="Step preview" priority width={IMAGE_WIDTH} height={IMAGE_HEIGHT} />
          <Styled.Info>
            <Styled.Title tagName="h2" html={step.strings.title} />
            {step.strings.description ? <Styled.Description tagName="div" html={step.strings.description} /> : null}
          </Styled.Info>
        </Styled.Step>)}
    </Styled.Wrapper>;
});